import { EchoesOfTwilight } from './src/EchoesOfTwilight.js';

window.customElements.define('echoes-of-twilight', EchoesOfTwilight);
